module.exports = __webpack_public_path__ + "img/加盟-授权-二次.7026b086.jpg";